export function LoadingSpinner() {
  return (
    <div className="loading-spinner" style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '50vh',
      fontSize: '18px',
    }}>
      <div>Loading...</div>
    </div>
  );
}
